<template>
  <Dialog :title="null" variant="narrow">
    <div class="flex flex-col pt-4 text-center">
      <ExclamationTriangleIcon class="mx-auto mb-2 size-9 text-gray-500" />
      <div class="mb-4 text-xl font-bold">Error</div>
      <div v-if="props.error.detail && Array.isArray(props.error.detail)">
        <div v-for="detail in props.error.detail" :key="detail">
          <div v-if="typeof detail === 'object'">
            <div v-for="(value, key) in detail" :key="key">
              <div class="font-bold">{{ key }}</div>
              <div>{{ value }}</div>
            </div>
          </div>
          <div v-else>{{ detail }}</div>
        </div>
      </div>
      <div v-else class="whitespace-pre-wrap text-lg">
        {{
          props.error.detail ||
          "Buttondown ran into an error.\n(Sorry, that's not helpful, but our team has been alerted.)"
        }}
      </div>

      <div v-if="shouldShowUpgradeButton" class="mt-4">
        <ActionButton
          text="Upgrade"
          :to="{ name: '/settings/billing/pricing' }"
          variant="primary"
        />
      </div>
    </div>
  </Dialog>
</template>

<script lang="ts" setup>
import { computed } from "vue";

import type { components as OpenAPI } from "@/autogen/openapi";
import ActionButton from "@/components/utilities/ActionButton.vue";
import Dialog from "@/design_system/shared/Dialog/Dialog.vue";
import ExclamationTriangleIcon from "@/icons/heroicons/exclamation-triangle-solid.svg";

const props = defineProps<{
  error: OpenAPI["schemas"]["ErrorMessage"];
}>();

const shouldShowUpgradeButton = computed(() => {
  return (
    props.error.detail?.includes("please upgrade your account") ||
    props.error.detail?.includes("upgrade your plan")
  );
});
</script>
